import {
    RaikoBaseCardContainer,
    RaikoCustomTable,
    RaikoGridOneColumn, RaikoTableTitleContainer,
    showErrorMessage,
    RaikoCustomTooltip
} from "@moeindal/base-raiko-panel-components";
import {useNavigate, useParams} from "react-router-dom";
import {GroupsService} from "../../../serverService/groups/GroupsService";
import {useAuthState} from "../../../context/AuthContext";
import {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {css} from "@emotion/css";
import {RouteHelper} from "../../../route/RouteHelper";

export default function GroupDetailUsers() {
    const {id: groupId} = useParams()

    const service = new GroupsService()
    const {fundID} = useAuthState()

    let page = 0
    const size = 15

    const [users, setUsers] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [tableLoadingState, setTableLoadingState] = useState(false);

    let navigate = useNavigate();

    useEffect(() => {
        if (groupId && groupId > 0)
            getGroupUsers()
    }, [groupId]);

    function getGroupUsers() {
        setTableLoadingState(true)
        service.getGroupUsers(
            fundID,
            groupId,
            page,
            size
        ).then(response => {
            setUsers([])
            response.data.map((item, index) => {
                setUsers(prevState => [
                    ...prevState,
                    prepareTableItems(
                        (size * page) + index + 1,
                        item.id,
                        `${item.firstName} ${item.lastName}`,
                        item.nationalCode,
                        item.phoneNumber
                    )
                ])
            })

            setPageCount(response.totalPage)
            setTotalItems(response.numberOfItems)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoadingState(false)
        })
    }

    function prepareTableItems(number, id, fullName, nationalCode, phoneNumber) {
        return {
            id,
            name: fullName,
            number,
            fullName,
            nationalCode,
            access: <div
                className={css`
                  display: flex;
                  justify-content: center;
                  gap: .5rem;`}>

                <RaikoCustomTooltip title={"جزئيات عضو"}>
                    <div
                        className={"ic-profile"}
                        onClick={_ => {
                            navigate(
                                RouteHelper.UserInformation.globalUrl.replace(":id", id),
                                {state: {title: fullName}, replace: false}
                            )
                        }}
                    />
                </RaikoCustomTooltip>
            </div>
        }
    }

    function handleChangePagination(newPage) {
        page = newPage
        getGroupUsers()
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"اعضا گروه"}
                        amount={totalItems}
                        hasCreateNewItem

                    />

                    <RaikoCustomTable
                        header={header}
                        data={users}
                        isLoading={tableLoadingState}
                        pageCount={pageCount}
                        handlePaginationChange={handleChangePagination}

                    />
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "fullName",
        label: "نام و نام خانوادگی"
    }, {
        id: "nationalCode",
        label: "کد ملی"
    }, {
        id: "access",
        label: "دسترسی"
    },
]
